import React, {useState} from 'react';
import ChooseTrue from "./icon/ChooseTrue";
import Choose from "./icon/Choose";
import '../SideBar/sidebar.css'
import {IOffices} from "../../types/types";
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import {useLocation} from 'react-router-dom'

const SidebarSection = ({item}: {item: IOffices}) => {
    const [active,setActive] = useState<boolean>(false);
    const { search } = useLocation();
    const connect = React.useMemo(() => (new URLSearchParams(search)).get('connect'), [search])

    return (
        <div className={'sidebar-select-items'}>
            <div className={'sidebar-select-header'} onClick={() => setActive(prev => !prev)}>
                <div className={'sidebar-select-header-item'}>
                    <div className={'sidebar-select-icon'} >
                        {item?.office ? <ChooseTrue/> : <Choose/>}
                    </div>
                </div>
                <div className={!active
                    ? 'sidebar-select-header-item sidebar-select-header-item-title'
                    : 'sidebar-select-header-item'}>
                    <div className={'sidebar-select-title'}>{item?.title}</div>
<div className="sidebar-select-header-item-border"/>

                </div>

            </div>
          <div className={`transition-all ${active ? 'max-content': 'hidden'}`}>
                    <div className={'sidebar-select-main-active'}>
                        <div className={'sidebar-select-main'}>
                          {item?.img && <div className={'sidebar-select-main-icon'}>
                            <img src={item?.img} className={'sidebar-select-main-img'}/>
                          </div>}
                        <div className={'sidebar-select-main-description'}
                             dangerouslySetInnerHTML={{
                               __html: documentToHtmlString(connect ? (item?.longDescription || item?.description): item?.description as any)
                             }}
                        />
                        </div>
                         <div className={'sidebar-select-main-border-active'}/>
                    </div>
          </div>
        </div>
    );
};

export default SidebarSection;